import { get } from './requests'

export const getAvailableCoaches = (key, params) => get(['public', 'coaches'], { key, params })
